// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"4bad3c94","787":"0a10ec7e"}[chunkId] + ".chunk.js";
};